import React, {createContext, ReactNode, useContext} from 'react';
import {FieldDependency} from "../components/content/C046FormEditor/FieldDependency";

interface PreviewContextType {
    isPreview: boolean;
}

interface Props {
    isPreview: boolean,
    children: ReactNode;
}

export const PreviewContext = createContext<PreviewContextType>({} as PreviewContextType);
const usePreviewContext = () => useContext(PreviewContext);


const PreviewProvider = (props: Props) => {
    return (
        <PreviewContext.Provider value={{isPreview: props.isPreview}}>
            {props.children}
        </PreviewContext.Provider>
    );
}

export {
    usePreviewContext,
    PreviewProvider
}
